/* eslint-disable @next/next/no-sync-scripts */
import React from 'react';
import classNames from 'classnames';
import Head from 'next/head';
import { useRouter } from 'next/router';
import styles from './CoverageMap.module.scss';
import CheckboxWithText from '../CheckboxWithText/CheckboxWithText';

const initData = () => {
  if (!window.mapboxgl?.Map) return;
  // todo: move to environments
  window.mapboxgl.accessToken =
    'pk.eyJ1IjoiYXJ0ZWZhbiIsImEiOiJjbDhkZHE3MTIxOWdpM3FuMzcxbDZxNHJqIn0.5GN-r6qgMwLriHS6pfmIxw';

  // innit map, set default configuration
  const map = new window.mapboxgl.Map({
    container: 'coverage-map',
    style: 'mapbox://styles/mapbox/light-v10',
    maxZoom: 13,
    minZoom: 9,
    zoom: 11,
    center: [49.81567, 40.3763],
  });

  // event
  map.on('load', () => {
    // add source
    map.addSource('3g', {
      type: 'image',
      url: 'https://i.imgur.com/znmJXGh.png',
      coordinates: [
        [49.646483, 40.504969],
        [50.116149, 40.512278],
        [50.131942, 40.270141],
        [49.663239, 40.273333],
      ],
    });

    // add layer. source is "map.addSource( this -> '3g'....."
    map.addLayer({
      id: '3g',
      type: 'raster',
      source: '3g',
      paint: {
        'raster-fade-duration': 0,
      },
    });

    // another source and layer ....
    map.addSource('4g', {
      type: 'image',
      url: 'https://i.imgur.com/c9atFqV.png',
      coordinates: [
        [49.469969, 40.565722],
        [50.341146, 40.609576],
        [50.351046, 40.304505],
        [49.619662, 40.281301],
      ],
    });
    map.addLayer({
      id: '4g',
      type: 'raster',
      source: '4g',
      paint: {
        'raster-fade-duration': 0,
      },
    });
  });

  return map;
};

const CoverageMap = () => {
  const router = useRouter();
  const mapRef = React.useRef(null);

  // todo: replace to data from backend
  const [activeState, setActiveState] = React.useState({
    '3g': true,
    '4g': true,
  });

  React.useEffect(() => {
    if (!router.isReady) return;
    setTimeout(() => {
      mapRef.current = initData();
    }, 1000);
    return () => {
      mapRef.current = null;
    };
  }, [router.isReady]);

  // todo: type === key from activeState === layer id
  const onClick = (type) => {
    if (activeState[type]) {
      mapRef.current.setLayoutProperty(type, 'visibility', 'none');
    } else {
      mapRef.current.setLayoutProperty(type, 'visibility', 'visible');
    }
    setActiveState({
      ...activeState,
      [type]: !activeState[type],
    });
  };

  // todo: create renderLayerButton method
  return (
    <div className={styles.map} itemScope itemType='https://schema.org/Map'>
      <Head>
        <meta name='viewport' content='initial-scale=1' />
        <link
          href='https://api.mapbox.com/mapbox-gl-js/v2.10.0/mapbox-gl.css'
          rel='stylesheet'
        />
        <script src='https://api.mapbox.com/mapbox-gl-js/v2.10.0/mapbox-gl.js' />
      </Head>
      <div className={styles.content}>
        <div className={styles.buttons}>
          <button
            onClick={() => onClick('3g')}
            className={classNames([
              styles.button,
              { [styles.active]: activeState['3g'] },
            ])}
            aria-label='3G'
          >
            <CheckboxWithText
              titleClassName={styles.checkboxTitle}
              className={styles.checkbox}
              checked={activeState['3g']}
            >
              <span className={styles.text}>3G</span>
            </CheckboxWithText>
          </button>
          <button
            onClick={() => onClick('4g')}
            className={classNames([
              styles.button,
              { [styles.active]: activeState['4g'] },
            ])}
            aria-label='4G'
          >
            <CheckboxWithText
              titleClassName={styles.checkboxTitle}
              className={styles.checkbox}
              checked={activeState['4g']}
            >
              <span className={styles.text}>4G</span>
            </CheckboxWithText>
          </button>
        </div>
        <div className={styles.map} id='coverage-map' />
      </div>
    </div>
  );
};

export default CoverageMap;
